





































































import { AccountTypeChip } from 'mycorems-app-accounts';
import { HasTaskMixin } from '@/mixins';
import eventBus from '@/messaging/event-bus';
import { ClientAdded, PricePlanStarted } from '@/messaging/events';
import {
  Client, ClientFilters, QueryResult, QPagination,
} from '@/types';
import ClientUsage from '@/account-price-plan/ClientUsage.vue';
import repository from './client-repository';

  interface Data {
    clients: Client[],
    pagination: QPagination,
    columns: object[],
  }

export default HasTaskMixin.extend({
  props: {
    agencyId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      clients: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      columns: [
        {
          name: 'name',
          align: 'left',
          label: 'Account Name',
          field: (c: Client) => c.name,
        },
        {
          name: 'createdAt',
          align: 'left',
          label: 'Added on',
          field: (c: Client) => c.createdAt,
        },
        {
          name: 'reports_used',
          align: 'center',
          label: 'Reports Used',
        },
        {
          name: 'client_subscribers',
          align: 'center',
          label: 'Subscribers',
        },
        {
          name: 'client_report_recipients',
          align: 'center',
          label: 'Report Recipients',
        },
        {
          name: 'client_campaigns',
          align: 'center',
          label: 'Campaigns',
        },
        {
          name: 'client_settings',
          align: 'center',
          label: 'Settings',
        },
      ],
    };
  },
  watch: {
    agencyId(): void {
      this.load();
    },
    pagination: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    filters(): ClientFilters {
      return {
        agencyId: this.agencyId,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
      };
    },
  },
  methods: {
    view(id: string, to: string): void {
      this.$router.push(`/accounts/${id}/${to}`);
    },
    load(): void {
      this.task = repository.findAll(this.filters);
      this.task.then((result: QueryResult) => {
        this.clients = result.items as Client[];
        this.pagination.rowsNumber = result.total;
      });
    },
  },
  created(): void {
    this.load();
    eventBus.$on(ClientAdded.eventName, this.load);
    eventBus.$on(PricePlanStarted.eventName, this.load);
  },
  beforeDestroy(): void {
    eventBus.$off(ClientAdded.eventName, this.load);
    eventBus.$off(PricePlanStarted.eventName, this.load);
  },
  components: {
    'client-usage': ClientUsage,
    'account-type-chip': AccountTypeChip,
  },
});
